import React, { createContext, useEffect, useState } from "react";
import { nonEmpty } from "../../../utils/service";
import { changePassword, userLogout  } from "../../../apis/Api";
import { useCookies } from 'react-cookie';
import { useNavigate, useLocation } from "react-router";
import OrderConstant from "../../../constants/contentFile.json";
import RouteConstant from "../../../constants/routesContent.json";
export const ResetPasswordContext = createContext({});

export const ResetPasswordContextProvider = ({ children }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [PasswordConfirm, setPasswordConfirm] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertReset, setShowAlertReset] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [newPasswordInvalid, setNewPasswordInvalid] = useState(false);
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [oldPasswordInvalid, setOldasswordInvalid] = useState(false);
  const [passWordMisMatch, setPasswordMisMatch] = useState(false);
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const [logoutAlertMessage, setLogoutAlertMessage] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const navigate = useNavigate();
  const orderConstants = OrderConstant.errorMessages;
  const logoutConstants = OrderConstant.logout;
  const location = useLocation();

  const submitnewPassword = async () => {
    if (!oldPassword) {
      setOldasswordInvalid(true);
    } else {
      setOldasswordInvalid(false);
    }
    if (!newPassword) {
      setNewPasswordInvalid(true);
    } else {
      setNewPasswordInvalid(false);
    }
    if (!PasswordConfirm) {
      setConfirmPasswordInvalid(true);
    } else {
      setConfirmPasswordInvalid(false);
    }
    if (
      nonEmpty(newPassword) &&
      nonEmpty(PasswordConfirm) &&
      nonEmpty(oldPassword)
    ) {
      if (newPassword === PasswordConfirm) {
        setPasswordMisMatch(false)
        try {
          const response = await changePassword(
            oldPassword,
            newPassword,
            PasswordConfirm
          );
          if (response.data.statusCode === 200) {
            if (newPassword === PasswordConfirm) {
              setAlertMessage("Password updated successfully");
              setShowAlert(true);
              setShowAlertReset(false);
              setPasswordMisMatch(false);
              setOldPassword("");
              setNewPassword("");
              setPasswordConfirm("");
            }
          }
        } catch (error) {
          const errorMessage = error.response.data.statusMessage;
          if (error.response.data.statusCode === 400) {
            setShowAlert(true);
            setShowAlertReset(false);
            setAlertMessage(errorMessage);
          } else if (error.response.data.statusCode === 401) {
            setShowAlert(false);
            setShowAlertReset(true);
            setAlertMessage('Session expired...Login to continue!!');
          }else if (error.response.data.statusCode === 403) {
            setShowAlert(true);
            setShowAlertReset(false);
            setAlertMessage(errorMessage);
          } else {
            setShowAlert(true);
            setShowAlertReset(false);
            setAlertMessage("Somethingwent wrong");
          }
        }
      } else {
        setPasswordMisMatch(true);
      }
    }
  };

  const handleAlertSubmit = () => {
    setShowAlert(false);
  };

  const logout = async () => {
    try {
      if (!cookies.xAccessToken) {
        removeCookie('xAccessToken', { path: '/' });
        removeCookie('supplierId', { path: '/' });
        removeCookie('intentToken', { path: '/' });
        removeCookie('userId', { path: '/' });
        navigate(RouteConstant.LOGIN);
      } else {
        const logoutData = await userLogout();
        if (logoutData?.data?.statusCode === 200) {
          removeCookie('xAccessToken', { path: '/' });
          removeCookie('supplierId', { path: '/' });
          removeCookie('userId', { path: '/' });
          removeCookie('intentToken', { path: '/' });
          navigate(RouteConstant.LOGIN);
        } else {
          setShowAlertReset(true);
          setShowAlert(false)
          setLogoutAlertMessage(orderConstants.somethingWrong);
        }
      }
    } catch (error) {
       setShowAlert(false);
       if (error?.response?.data?.statusCode === 401) {
        setShowLogoutAlert(false);
        navigate(RouteConstant.LOGIN);
      } else {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(orderConstants.somethingWrong);
      }
    }
  };

  const providerValue = {
    submitnewPassword,
    oldPassword,
    setOldPassword,
    oldPasswordInvalid,
    setNewPassword,
    newPassword,
    newPasswordType,
    handleAlertSubmit,
    logout,
    setNewPasswordType,
    passwordType,
    setPasswordType,
    setShowAlert,
    alertMessage,
    showAlert,
    confirmPasswordType,
    setConfirmPasswordType,
    PasswordConfirm,
    setPasswordConfirm,
    newPasswordInvalid,
    confirmPasswordInvalid,
    passWordMisMatch,
    showAlertReset,
    setShowAlertReset,
    setShowLogoutAlert,
    showLogoutAlert,
    logoutAlertMessage,
    logoutConstants,
  };

  return (
    <ResetPasswordContext.Provider value={providerValue}>
      {children}
    </ResetPasswordContext.Provider>
  );
};
